import React, { FunctionComponent } from "react";

export const ResetPasswordForm: FunctionComponent = () => (
  <div>ResetPasswordForm</div>
);
